import { useEffect } from 'react'

import { useSetState } from '@domain-group/react-hooks'

import { getFullAddress } from '@functions/campaign'
import { geocodeAddress as geocodeAddressFn } from '@functions/geocode'

import type { CampaignModel } from '@models/types'

const defaultState = {
  address: '',
  editing: false,
  geocodePerformed: true,
  latitude: null,
  loading: false,
  longitude: null,
}

type SetState = (state: Partial<typeof defaultState>) => void

async function geocodeAddress(address: string, setState: SetState) {
  setState({ loading: true })

  const result = await geocodeAddressFn(address)

  if (result.success){
    const { lat, lng } = result.location

    setState({
      geocodePerformed: true,
      latitude: lat,
      longitude: lng,
    })
  }

  setState({ loading: false })
  return result
}

const setupState = (campaign: CampaignModel, setState: SetState) => {
  const { latitude, longitude } = campaign

  const address = getFullAddress(campaign)

  setState({
    address,
    // @ts-expect-error TS2322
    latitude: latitude || '',
    // @ts-expect-error TS2322
    longitude: longitude || '',
  })
}

function useGeocode(campaign: CampaignModel) {
  const [state, setState] = useSetState(defaultState)
  const {
    address, editing, geocodePerformed, latitude, loading, longitude,
  } = state

  useEffect(() => setupState(campaign, setState), [campaign.latitude, campaign.longitude])

  const isEnabled = latitude !== '' && longitude !== ''
  const saveEnabled = geocodePerformed === true

  return {
    address,
    callbacks: {
      geocodeAddress: () => geocodeAddress(address, setState),
      setGeocodeState: (values: Partial<typeof defaultState>) => setState(values),
    },
    editing,
    isEnabled,
    latitude,
    loading,
    longitude,
    saveEnabled,
  }
}

export type UseGeocodePayload = ReturnType<typeof useGeocode>

export default useGeocode
